/**
 * @generated SignedSource<<19c9defaee1f455d898315ff113a891c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EventList_eventsConnection$data = {
  readonly edges: ReadonlyArray<{
    readonly cursor: String;
    readonly node: {
      readonly startAt: String;
      readonly " $fragmentSpreads": FragmentRefs<"EventItemNew_event">;
    };
  }>;
  readonly " $fragmentType": "EventList_eventsConnection";
};
export type EventList_eventsConnection$key = {
  readonly " $data"?: EventList_eventsConnection$data;
  readonly " $fragmentSpreads": FragmentRefs<"EventList_eventsConnection">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EventList_eventsConnection",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "EventsEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Event",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "startAt",
              "storageKey": null
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "EventItemNew_event"
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "cursor",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "EventsConnection",
  "abstractKey": null
};

(node as any).hash = "4f2d83ea5557f6c506e7aa6e81c47cb6";

export default node;
